import React from 'react';

const questions = require('./questionlist.json')

const QuestionDisplay = () => {
    const checkquestion = () => {
        console.log(questions)
    }
    return (
        <div id='question-list'>
            {questions.map(question => (
                <div style={{textAlign: 'left', marginBottom: '10px'}}>
                    <div className='ques'>
                        Q{question.id}. {question.question}
                    </div>

                    <div className='ans'>
                        A.{question.answer}
                    </div>

                </div>
            ))}
        </div>
    )
}

export default QuestionDisplay;